// Logistics Table Component with AlpineJS functionality
const logisticsTable = () => {
  return {
    page: 1,
    perPage: 5,
    search: '',
    selectedRows: [],
    allSelected: false,
    sort: { column: "", asc: true },
    
    rows: [
      {
        id: "#324112",
        category: "Furniture",
        company: "HomeLine",
        arrival: "10 Apr 2028 2:15 pm",
        route: "Berlin–Milan",
        price: "$1,250.00",
        status: "Delivered",
        statusClass: "bg-success-50 dark:bg-success-500/15 text-success-700 dark:text-success-500 text-theme-xs rounded-full px-2 py-0.5 font-medium",
      },
      {
        id: "#325678",
        category: "Clothing",
        company: "StylePro",
        arrival: "21 May 2028 9:00 am",
        route: "Paris–Rome",
        price: "$340.75",
        status: "Delivered",
        statusClass: "bg-success-50 dark:bg-success-500/15 text-success-700 dark:text-success-500 text-theme-xs rounded-full px-2 py-0.5 font-medium",
      },
      {
        id: "#326789",
        category: "Books",
        company: "EduSource",
        arrival: "02 Jun 2028 11:45 am",
        route: "New York–Chicago",
        price: "$128.40",
        status: "In Transit",
        statusClass: "bg-warning-50 dark:bg-warning-500/15 text-warning-600 dark:text-warning-400 text-theme-xs rounded-full px-2 py-0.5 font-medium",
      },
      {
        id: "#327003",
        category: "Automotive",
        company: "AutoParts Co.",
        arrival: "18 Mar 2028 4:00 pm",
        route: "Tokyo–Osaka",
        price: "$2,150.89",
        status: "Delivered",
        statusClass: "bg-success-50 dark:bg-success-500/15 text-success-700 dark:text-success-500 text-theme-xs rounded-full px-2 py-0.5 font-medium",
      },
      {
        id: "#328556",
        category: "Electronics",
        company: "TechNova",
        arrival: "25 Jul 2028 10:30 am",
        route: "San Francisco–Seattle",
        price: "$849.99",
        status: "Delivered",
        statusClass: "bg-success-50 dark:bg-success-500/15 text-success-700 dark:text-success-500 text-theme-xs rounded-full px-2 py-0.5 font-medium",
      },
      {
        id: "#329101",
        category: "Health",
        company: "MediCorp",
        arrival: "30 May 2028 3:00 pm",
        route: "Toronto–Vancouver",
        price: "$579.20",
        status: "Delivered",
        statusClass: "bg-success-50 dark:bg-success-500/15 text-success-700 dark:text-success-500 text-theme-xs rounded-full px-2 py-0.5 font-medium",
      },
      {
        id: "#330212",
        category: "Toys",
        company: "FunTime",
        arrival: "07 Jun 2028 1:15 pm",
        route: "Sydney–Melbourne",
        price: "$212.65",
        status: "Delivered",
        statusClass: "bg-success-50 dark:bg-success-500/15 text-success-700 dark:text-success-500 text-theme-xs rounded-full px-2 py-0.5 font-medium",
      },
      {
        id: "#331145",
        category: "Kitchen",
        company: "CookWell",
        arrival: "13 May 2028 12:30 pm",
        route: "Madrid–Barcelona",
        price: "$489.90",
        status: "Delivered",
        statusClass: "bg-success-50 dark:bg-success-500/15 text-success-700 dark:text-success-500 text-theme-xs rounded-full px-2 py-0.5 font-medium",
      },
      {
        id: "#332800",
        category: "Beauty",
        company: "GlamShine",
        arrival: "28 Jun 2028 5:45 pm",
        route: "Dubai–Doha",
        price: "$323.75",
        status: "Canceled",
        statusClass: "text-theme-xs rounded-full bg-red-50 px-2 py-0.5 font-medium text-red-600 dark:bg-red-500/15 dark:text-red-500",
      },
      {
        id: "#333902",
        category: "Sports",
        company: "FitZone",
        arrival: "19 Jul 2028 8:00 am",
        route: "Los Angeles–Las Vegas",
        price: "$489.90",
        status: "$675.00",
        statusClass: "bg-success-50 dark:bg-success-500/15 text-success-700 dark:text-success-500 text-theme-xs rounded-full px-2 py-0.5 font-medium",
      },
    ],

    init() {
      this.$watch('allSelected', value => {
        if (value) {
          this.selectedRows = this.paginatedRows.map(item => item.id);
        } else {
          this.selectedRows = [];
        }
      });

      this.$watch('selectedRows', value => {
        this.allSelected = value.length === this.paginatedRows.length && this.paginatedRows.length > 0;
      });
    },

    get totalPages() {
      return Math.ceil(this.rows.length / this.perPage);
    },

    get startRow() {
      return (this.page - 1) * this.perPage;
    },

    get endRow() {
      return this.page * this.perPage;
    },

    get paginatedRows() {
      let sorted = [...this.rows];
      if (this.sort.column) {
        sorted.sort((a, b) => {
          let valA = a[this.sort.column];
          let valB = b[this.sort.column];
          if (this.sort.column === "arrival") {
            return (new Date(valA) - new Date(valB)) * (this.sort.asc ? 1 : -1);
          }
          if (valA < valB) return this.sort.asc ? -1 : 1;
          if (valA > valB) return this.sort.asc ? 1 : -1;
          return 0;
        });
      }
      return sorted.slice(this.startRow, this.endRow);
    },

    toggleAll() {
      if (this.allSelected) {
        this.selectedRows = [];
        this.allSelected = false;
      } else {
        this.selectedRows = this.rows.map((r) => r.id);
        this.allSelected = true;
      }
    },

    toggleRow(id) {
      if (this.selectedRows.includes(id)) {
        this.selectedRows = this.selectedRows.filter((r) => r !== id);
      } else {
        this.selectedRows.push(id);
      }
      this.allSelected = this.selectedRows.length === this.rows.length;
    },

    sortBy(col) {
      if (this.sort.column === col) {
        this.sort.asc = !this.sort.asc;
      } else {
        this.sort.column = col;
        this.sort.asc = true;
      }
    },

    prevPage() {
      if (this.page > 1) this.page--;
    },

    nextPage() {
      if (this.page < this.totalPages) this.page++;
    },

    goToPage(n) {
      this.page = n;
    }
  };
};

export default logisticsTable;